import { BaseIcon } from './base';
import type { IconSmallProps } from './base';

export function IconNotesSmall(props: IconSmallProps) {
  return (
    <BaseIcon {...props} size={16} viewBox="0 0 16 16">
      <path
        d="M2 5C2 4.44772 2.44772 4 3 4H13C13.5523 4 14 4.44772 14 5C14 5.55228 13.5523 6 13 6H3C2.44772 6 2 5.55228 2 5ZM2 8C2 7.44772 2.44772 7 3 7H13C13.5523 7 14 7.44772 14 8C14 8.55228 13.5523 9 13 9H3C2.44772 9 2 8.55228 2 8ZM3 10C2.44772 10 2 10.4477 2 11C2 11.5523 2.44772 12 3 12H8C8.55228 12 9 11.5523 9 11C9 10.4477 8.55228 10 8 10H3Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
